export default {
    state: 'idle',
    message: 'default messsage'
}